import { SupportProjectsActions, ESupportProjectsActions } from "@edp-store/actions/support-projects.action";
import { initialSupportProjectsState, ISupportProjectsState } from "@edp-store/state/support-projects.state";

export function supportProjectsReducers(state = initialSupportProjectsState, action: SupportProjectsActions): ISupportProjectsState {
    switch (action.type) {
        case ESupportProjectsActions.SaveDonation: {
            return {
                ...state,
                supportProjects: action.payload,
            };
        }
        case ESupportProjectsActions.SetGasCompensation: {
            return {
                ...state,
                supportProjectsGasCompensation: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
